module.exports = __webpack_public_path__ + "files/cfbd200d42bb33888da35941a3871e41.png";